import { SelectFieldOption } from '@resurs-internal/mui/components/SelectField/SelectFieldOption';

/**
 * Static ISO 3166-1 alpha-2 country list with Danish names, used as a v1 fallback
 * for `applicantAncestralHomeland` (country of birth) until backend confirms/exposes
 * a canonical country list — see LP-2842. Ids are uppercase to match the confirmed
 * `"applicantAncestralHomeland": "SE"` example in LP-2077's draft payload; this is a
 * different backend field/contract than the unrelated lowercase `kycCountries` list
 * (`KycQuestion.tsx`), so the differing casing is intentional, not a mismatch.
 */
export const countries: SelectFieldOption[] = [
    { id: 'AF', label: 'Afghanistan' },
    { id: 'AL', label: 'Albanien' },
    { id: 'DZ', label: 'Algeriet' },
    { id: 'AD', label: 'Andorra' },
    { id: 'AO', label: 'Angola' },
    { id: 'AG', label: 'Antigua og Barbuda' },
    { id: 'AR', label: 'Argentina' },
    { id: 'AM', label: 'Armenien' },
    { id: 'AU', label: 'Australien' },
    { id: 'AT', label: 'Østrig' },
    { id: 'AZ', label: 'Aserbajdsjan' },
    { id: 'BS', label: 'Bahamas' },
    { id: 'BH', label: 'Bahrain' },
    { id: 'BD', label: 'Bangladesh' },
    { id: 'BB', label: 'Barbados' },
    { id: 'BY', label: 'Hviderusland' },
    { id: 'BE', label: 'Belgien' },
    { id: 'BZ', label: 'Belize' },
    { id: 'BJ', label: 'Benin' },
    { id: 'BT', label: 'Bhutan' },
    { id: 'BO', label: 'Bolivia' },
    { id: 'BA', label: 'Bosnien-Hercegovina' },
    { id: 'BW', label: 'Botswana' },
    { id: 'BR', label: 'Brasilien' },
    { id: 'BN', label: 'Brunei' },
    { id: 'BG', label: 'Bulgarien' },
    { id: 'BF', label: 'Burkina Faso' },
    { id: 'BI', label: 'Burundi' },
    { id: 'KH', label: 'Cambodja' },
    { id: 'CM', label: 'Cameroun' },
    { id: 'CA', label: 'Canada' },
    { id: 'CV', label: 'Kap Verde' },
    { id: 'CF', label: 'Den Centralafrikanske Republik' },
    { id: 'TD', label: 'Tchad' },
    { id: 'CL', label: 'Chile' },
    { id: 'CN', label: 'Kina' },
    { id: 'CO', label: 'Colombia' },
    { id: 'KM', label: 'Comorerne' },
    { id: 'CG', label: 'Congo-Brazzaville' },
    { id: 'CD', label: 'Congo-Kinshasa' },
    { id: 'CR', label: 'Costa Rica' },
    { id: 'CI', label: 'Elfenbenskysten' },
    { id: 'HR', label: 'Kroatien' },
    { id: 'CU', label: 'Cuba' },
    { id: 'CY', label: 'Cypern' },
    { id: 'CZ', label: 'Tjekkiet' },
    { id: 'DK', label: 'Danmark' },
    { id: 'DJ', label: 'Djibouti' },
    { id: 'DM', label: 'Dominica' },
    { id: 'DO', label: 'Den Dominikanske Republik' },
    { id: 'EC', label: 'Ecuador' },
    { id: 'EG', label: 'Egypten' },
    { id: 'SV', label: 'El Salvador' },
    { id: 'GQ', label: 'Ækvatorialguinea' },
    { id: 'ER', label: 'Eritrea' },
    { id: 'EE', label: 'Estland' },
    { id: 'SZ', label: 'Eswatini' },
    { id: 'ET', label: 'Etiopien' },
    { id: 'FJ', label: 'Fiji' },
    { id: 'FI', label: 'Finland' },
    { id: 'FR', label: 'Frankrig' },
    { id: 'GA', label: 'Gabon' },
    { id: 'GM', label: 'Gambia' },
    { id: 'GE', label: 'Georgien' },
    { id: 'DE', label: 'Tyskland' },
    { id: 'GH', label: 'Ghana' },
    { id: 'GR', label: 'Grækenland' },
    { id: 'GL', label: 'Grønland' },
    { id: 'GD', label: 'Grenada' },
    { id: 'GT', label: 'Guatemala' },
    { id: 'GN', label: 'Guinea' },
    { id: 'GW', label: 'Guinea-Bissau' },
    { id: 'GY', label: 'Guyana' },
    { id: 'HT', label: 'Haiti' },
    { id: 'HN', label: 'Honduras' },
    { id: 'HK', label: 'Hongkong' },
    { id: 'HU', label: 'Ungarn' },
    { id: 'IS', label: 'Island' },
    { id: 'IN', label: 'Indien' },
    { id: 'ID', label: 'Indonesien' },
    { id: 'IR', label: 'Iran' },
    { id: 'IQ', label: 'Irak' },
    { id: 'IE', label: 'Irland' },
    { id: 'IL', label: 'Israel' },
    { id: 'IT', label: 'Italien' },
    { id: 'JM', label: 'Jamaica' },
    { id: 'JP', label: 'Japan' },
    { id: 'JO', label: 'Jordan' },
    { id: 'KZ', label: 'Kasakhstan' },
    { id: 'KE', label: 'Kenya' },
    { id: 'KI', label: 'Kiribati' },
    { id: 'XK', label: 'Kosovo' },
    { id: 'KW', label: 'Kuwait' },
    { id: 'KG', label: 'Kirgisistan' },
    { id: 'LA', label: 'Laos' },
    { id: 'LV', label: 'Letland' },
    { id: 'LB', label: 'Libanon' },
    { id: 'LS', label: 'Lesotho' },
    { id: 'LR', label: 'Liberia' },
    { id: 'LY', label: 'Libyen' },
    { id: 'LI', label: 'Liechtenstein' },
    { id: 'LT', label: 'Litauen' },
    { id: 'LU', label: 'Luxembourg' },
    { id: 'MO', label: 'Macao' },
    { id: 'MG', label: 'Madagaskar' },
    { id: 'MW', label: 'Malawi' },
    { id: 'MY', label: 'Malaysia' },
    { id: 'MV', label: 'Maldiverne' },
    { id: 'ML', label: 'Mali' },
    { id: 'MT', label: 'Malta' },
    { id: 'MH', label: 'Marshalløerne' },
    { id: 'MR', label: 'Mauretanien' },
    { id: 'MU', label: 'Mauritius' },
    { id: 'MX', label: 'Mexico' },
    { id: 'FM', label: 'Mikronesien' },
    { id: 'MD', label: 'Moldova' },
    { id: 'MC', label: 'Monaco' },
    { id: 'MN', label: 'Mongoliet' },
    { id: 'ME', label: 'Montenegro' },
    { id: 'MA', label: 'Marokko' },
    { id: 'MZ', label: 'Mozambique' },
    { id: 'MM', label: 'Myanmar' },
    { id: 'NA', label: 'Namibia' },
    { id: 'NR', label: 'Nauru' },
    { id: 'NP', label: 'Nepal' },
    { id: 'NL', label: 'Holland' },
    { id: 'NZ', label: 'New Zealand' },
    { id: 'NI', label: 'Nicaragua' },
    { id: 'NE', label: 'Niger' },
    { id: 'NG', label: 'Nigeria' },
    { id: 'KP', label: 'Nordkorea' },
    { id: 'MK', label: 'Nordmakedonien' },
    { id: 'NO', label: 'Norge' },
    { id: 'OM', label: 'Oman' },
    { id: 'PK', label: 'Pakistan' },
    { id: 'PW', label: 'Palau' },
    { id: 'PS', label: 'Palæstina' },
    { id: 'PA', label: 'Panama' },
    { id: 'PG', label: 'Papua Ny Guinea' },
    { id: 'PY', label: 'Paraguay' },
    { id: 'PE', label: 'Peru' },
    { id: 'PH', label: 'Filippinerne' },
    { id: 'PL', label: 'Polen' },
    { id: 'PT', label: 'Portugal' },
    { id: 'QA', label: 'Qatar' },
    { id: 'RO', label: 'Rumænien' },
    { id: 'RU', label: 'Rusland' },
    { id: 'RW', label: 'Rwanda' },
    { id: 'KN', label: 'Saint Kitts og Nevis' },
    { id: 'LC', label: 'Saint Lucia' },
    { id: 'VC', label: 'Saint Vincent og Grenadinerne' },
    { id: 'WS', label: 'Samoa' },
    { id: 'SM', label: 'San Marino' },
    { id: 'ST', label: 'São Tomé og Príncipe' },
    { id: 'SA', label: 'Saudi-Arabien' },
    { id: 'SN', label: 'Senegal' },
    { id: 'RS', label: 'Serbien' },
    { id: 'SC', label: 'Seychellerne' },
    { id: 'SL', label: 'Sierra Leone' },
    { id: 'SG', label: 'Singapore' },
    { id: 'SK', label: 'Slovakiet' },
    { id: 'SI', label: 'Slovenien' },
    { id: 'SB', label: 'Salomonøerne' },
    { id: 'SO', label: 'Somalia' },
    { id: 'ZA', label: 'Sydafrika' },
    { id: 'KR', label: 'Sydkorea' },
    { id: 'SS', label: 'Sydsudan' },
    { id: 'ES', label: 'Spanien' },
    { id: 'LK', label: 'Sri Lanka' },
    { id: 'SD', label: 'Sudan' },
    { id: 'SR', label: 'Surinam' },
    { id: 'SE', label: 'Sverige' },
    { id: 'CH', label: 'Schweiz' },
    { id: 'SY', label: 'Syrien' },
    { id: 'TW', label: 'Taiwan' },
    { id: 'TJ', label: 'Tadsjikistan' },
    { id: 'TZ', label: 'Tanzania' },
    { id: 'TH', label: 'Thailand' },
    { id: 'TL', label: 'Østtimor' },
    { id: 'TG', label: 'Togo' },
    { id: 'TO', label: 'Tonga' },
    { id: 'TT', label: 'Trinidad og Tobago' },
    { id: 'TN', label: 'Tunesien' },
    { id: 'TR', label: 'Tyrkiet' },
    { id: 'TM', label: 'Turkmenistan' },
    { id: 'TV', label: 'Tuvalu' },
    { id: 'UG', label: 'Uganda' },
    { id: 'UA', label: 'Ukraine' },
    { id: 'AE', label: 'De Forenede Arabiske Emirater' },
    { id: 'GB', label: 'Storbritannien' },
    { id: 'US', label: 'USA' },
    { id: 'UY', label: 'Uruguay' },
    { id: 'UZ', label: 'Usbekistan' },
    { id: 'VU', label: 'Vanuatu' },
    { id: 'VA', label: 'Vatikanstaten' },
    { id: 'VE', label: 'Venezuela' },
    { id: 'VN', label: 'Vietnam' },
    { id: 'YE', label: 'Yemen' },
    { id: 'ZM', label: 'Zambia' },
    { id: 'ZW', label: 'Zimbabwe' },
];
